import ErrorBox from '../components/error/Error'

function Error(){
    return (
        <div className="error-wrapper">
            <ErrorBox />
        </div>
    )
}

export default Error